module.exports = __webpack_public_path__ + "img/xiexiaoming_p.680c655d.png";